import { ITheme } from '@fluentui/react';

import {
  ActionControlSemanticColors,
  depths,
  fluentUIDepths,
  getActionControlSemanticColorsWithTheme,
  getModernUxExperimentPreference,
} from '@1js/acui-common';
import { isReducedAnimations } from '@1js/window-util';

import { getModeStylingConstants, ribbonStylingConstants } from '../../ribbonStylingConstants';
import { RibbonMode } from '../Ribbon/Ribbon.Props';
import { getRibbonHeightTransition } from './RibbonBottomBar.classNames';
/**
 * The styles for the wrapper div of the Ribbon Bottom Bar.
 *
 * Since these styles may be used by Ribbon placeholders that are rendered early in the boot sequence,
 * we don't want dependencies here on fabric utilities like merge-styles.
 */
export const getRibbonBottomBarWrapperStyles = (theme: ITheme, ribbonMode: RibbonMode) => {
  const actionControlSemanticColors: ActionControlSemanticColors = getActionControlSemanticColorsWithTheme(theme);
  return {
    height: getModeStylingConstants(ribbonMode).bottomBarHeight,
    backgroundColor: actionControlSemanticColors.defaultBackgroundColor,
    borderBottom: '1px solid #C8C8C8',
    transition: getRibbonHeightTransition(isReducedAnimations()),
  };
};

export const getPlaceholderBottomBarWrapperStyles = (theme: ITheme, mode: RibbonMode) => {
  return {
    ...getRibbonBottomBarWrapperStyles(theme, mode),
    borderBottom: 'none',
    // This is needed so we don't have overflow and it needs to be bound to a type (vs string)
    boxSizing: 'border-box' as 'border-box',
  };
};

export const getRibbonBottomBarWrapperShadowStyles = (theme: ITheme, mode: RibbonMode) => {
  return {
    ...getPlaceholderBottomBarWrapperStyles(theme, mode),
    boxShadow: getModernUxExperimentPreference() ? fluentUIDepths.depth4 : depths.depth4,
    /**
     * The z-index be lower than RibbonTopBar because the box-shadow above leaks above the top of the bottom bar.
     * The TopBar should hide that.
     */
    zIndex: ribbonStylingConstants.bottomBarZIndex,
    /**
     * position is defined as specific strings like 'relative' or 'absolute'
     */
    position: 'relative' as 'relative',
  };
};
